import React, {useState} from 'react';
import { Modal, Icon, Fab, Page } from 'react-onsenui';
import { Grid } from 'antd-mobile';
import _ from 'lodash';
import debut from '../../../images/actions/debut.svg';
import mitemps from '../../../images/actions/mitemps.svg';
import reprise from '../../../images/actions/reprise.svg';
import fin from '../../../images/actions/fin.svg';
import prolong from '../../../images/actions/prolong.svg';
import tab from '../../../images/actions/tab.svg';
import but from '../../../images/actions/but.svg';
import remplacement from '../../../images/actions/remplacement.svg';
import cartons from '../../../images/actions/cartons.svg';
import tir from '../../../images/actions/tir.svg';
import penalty from '../../../images/actions/penalty.svg';
import cpa from '../../../images/actions/cpa.svg';
import { useHistory } from 'react-router-dom';
import { 
    isLiveInProgress, 
    getChronoFromLiveDebut, 
    extractAction, 
    getRegularTimeForAction,
    getLivePeriod,
    isLiveInHalfTime,
    isLiveEnded,
    isLiveReadyToOvertime,
    isRegularTimeEnd,
    isOverTimeStarted,
    isOvertimeEnd,
    getHalfTimeCaracteristique
} from '../../../helpers';
import PropTypes from 'prop-types';
import ConfirmModal from '../confirm/ConfirmModal';
import { addAction, edit as editLive } from '../../../services/live';
import { bindActionCreators } from 'redux';
import { addActionLive, endLive } from '../../../actions/liveDataActions';
import { connect } from 'react-redux';
import moment from 'moment';
import EndDeclarationModal from '../enddeclaration/EndDeclarationModal';
import { FIRST_PERIOD, SECOND_PERIOD, FIRST_PERIOD_PROLONGATION, SECOND_PERIOD_PROLONGATION } from '../../../constants';

const DeclarationActionModal = props => {
    const history = useHistory();
    const [showMitempModal, setShowMitempModal] = useState(false);
    const [showRepriseModal, setShowRepriseModal] = useState(false);
    const [showEndMatch, setShowEndMatch] = useState(false);
    const [onProgress, setOnProgress] = useState(false);

    const highlights = [
        {icon: debut, text: 'Début',
            handleClick: () => {
                const action = _.pick(_.find(props.actionType, {name: 'Début'}), '@id');
                const settings = {debutAt: props.match.date}
                history.push(`/live/${props.id}/debut?action_type=${JSON.stringify(action)}&settings=${JSON.stringify(settings)}`) 
            },
            isActive: !isLiveInProgress(props.live) && !isLiveEnded(props.live)
        },
        {
            icon: mitemps, 
            text: 'Mi-temps', 
            handleClick: () => setShowMitempModal(true), 
            isActive: isLiveInProgress(props.live) && (_.includes([FIRST_PERIOD_PROLONGATION, FIRST_PERIOD],getLivePeriod(props.live.actions)))
        },
        {
            icon: reprise, 
            text: 'Reprise', 
            handleClick: () => setShowRepriseModal(true), 
            isActive: isLiveInHalfTime(props.live.actions) 
        },
        {
            icon: fin, 
            text: 'Fin', 
            handleClick: () => setShowEndMatch(true), 
            isActive: isLiveInProgress(props.live) && _.includes([SECOND_PERIOD, SECOND_PERIOD_PROLONGATION],getLivePeriod(props.live.actions)) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)
        }
    ];

    const overtime = [
        {icon: prolong, text: 'Prolong.', 
            handleClick: () => {
                const action = _.pick(_.find(props.actionType, {name: 'Prolongations'}), ['@id', 'name']);
                const settings = {debutAt: moment().format('YYYYMMDDHm'), minute: parseInt(getHalfTimeCaracteristique(props.live.actions, SECOND_PERIOD)) || 0}
                history.push(`/live/${props.id}/prolongations?action_type=${JSON.stringify(action)}&settings=${JSON.stringify(settings)}`)
            },isActive: isLiveReadyToOvertime(props.live)},
        {
            icon: tab, 
            text: 'Tirs au but', 
            handleClick: () => {
               const action = _.pick(_.find(props.actionType, {name: 'Séance de tirs aux buts'}), '@id');
               const endRegularTime = extractAction(props.live.actions, 'fin_prolongations') ? extractAction(props.live.actions, 'fin_prolongations') : extractAction(props.live.actions, 'fin_temps_reglementaire');
               history.push(`/live/${props.id}/tab?action_type=${JSON.stringify(action)}&minute=${parseInt(getRegularTimeForAction(props.live.actions, endRegularTime) || 0)}`)
            }, 
            isActive: (isLiveReadyToOvertime(props.live) || isOvertimeEnd(props.live.actions)) && !isLiveEnded(props.live)
        }
    ];

    const actions = [
        {icon: but, text: 'But !', props: {
            history,
            to: `/live/${props.id}/but`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {name: 'But'}), ['data', '@id'])),
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)},
        {icon: remplacement, text: 'Remplacement', props: {
            history,
            to: `/live/${props.id}/substitution`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {name: 'Remplacement'}), ['data', '@id'])),
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)},
        {icon: cartons, text: 'Cartons', props: {
            history,
            to: `/live/${props.id}/cartons`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {name: 'Cartons'}), ['data', '@id'])),
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)},
        {icon: tir, text: 'Tirs', props: {
            history,
            to: `/live/${props.id}/tir`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {name: 'Tir'}), ['data', '@id'])),
            settings: {
                tir: 'tir'
            },
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)},
        {icon: penalty, text: 'Penalty', props: {
            history,
            to: `/live/${props.id}/penalty_declaration`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {slug: 'penalty_declaration'}), ['@id', 'slug'])),
            settings: {
                penaltyResultSettings: _.pick(_.find(props.actionType, {slug: 'penalty_resultat'}), ['@id', 'slug'])
            },
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)},
        {icon: cpa, text: 'Coup de pied arrêté', props: {
            history,
            to: `/live/${props.id}/coup-de-pied-arrete`,
            action: JSON.stringify(_.pick(_.find(props.actionType, {name: 'Coup de pied arrêté'}), ['data', '@id'])),
            settings: {
                tir: 'coup de pied arrêté'
            },
            live: props.live
        },isActive: isLiveInProgress(props.live) && !isLiveInHalfTime(props.live.actions) && !isRegularTimeEnd(props.live.actions) && !isOvertimeEnd(props.live.actions)}
    ]

    return (
        <Modal isOpen={props.open} animation='lift' animationOptions={{duration: 0.2, delay: 0.4, timing: 'ease-in'}}>
            <Page modifier='ls_page_declare_action'>
                <Grid 
                    hasLine={false} 
                    data={highlights}
                    onClick={o => o.isActive ? o.handleClick() : () => {}}
                    renderItem={el => {
                        return (
                            <div className="am-grid-item-inner-content column-num-4" style={{opacity: el.isActive ? 1 : 0.2}}>
                                <img className="am-grid-icon" src={el.icon} alt={el.text} />
                                <div className="am-grid-text">{el.text}</div>
                            </div>
                        );
                    }} 
                />
                <div className='ls_overtime'>
                    <Grid 
                        hasLine={false} 
                        data={overtime} 
                        columnNum={2}
                        onClick={o => o.isActive ? o.handleClick() : () => {}}
                        renderItem={el => renderItemGrid(el)}
                    />
                </div>
                <div className='ls_actions_btn'>
                    <Grid 
                        data={actions} 
                        columnNum={2}
                        onClick={o => o.isActive ? handleClickActions(o.props) : () => {}}
                        renderItem={el => renderItemGrid(el)}
                    />
                </div>
                <div className='ls_close_declare_action'>
                    <Fab 
                        modifier='ls_fab_close' 
                        position='bottom right'
                        onClick={props.onCancel}
                    >
                        <Icon icon='md-close' size={26} />
                    </Fab>
                </div>
                <ConfirmModal
                    show={showMitempModal}
                    title={'C\'est la mi-temps ?'}
                    content='En cliquant sur "OK" tu mettras ton live en pause et les spectateurs seront notifiés de cette action.'
                    onCancel={() => setShowMitempModal(false)}
                    disabled={onProgress}
                    onOk={() => {
                        const { actions } = props.live;
                        const action = _.pick(_.find(props.actionType, {name: 'Mi-temps'}), '@id');
                        const minute = parseInt(getChronoFromLiveDebut(actions)) < parseInt(getHalfTimeCaracteristique(actions, getLivePeriod(actions))) ? parseInt(getHalfTimeCaracteristique(actions, getLivePeriod(actions))) : parseInt(getChronoFromLiveDebut(actions))
                        const isOvertime = isOverTimeStarted(actions);
                        setOnProgress(true);
                        addAction(props.id, {
                            type: action['@id'],
                            teamId: null,
                            minute,
                            teamName: null,
                            data: {
                                actionName: `Fin de la première période ${isOvertime ? 'de la prolongation' : ''}`,
                                label: isOvertime ? 'mi_temps_prolongation' : 'mi_temps'
                            }
                        }, props.access).then(response => {
                            window.postMessage(JSON.stringify({
                                action: 'trackEvent',
                                parameters: {
                                    label: 'added_live_score',
                                    value: 'déclarer mi-temps'
                                }
                            }), '*');
                            setTimeout(() => setOnProgress(false), 1000);
                            props.addActionLive(props.id, response.data);
                            setShowMitempModal(false);
                            props.onCancel();
                        })
                    }}
                />
                <ConfirmModal
                    show={showRepriseModal}
                    title={'Le match recommence ?'}
                    content='En cliquant sur "OK" tu vas reprendre la saisie live du match en cours et notifier tes spectateurs de la reprise.'
                    onCancel={() => setShowRepriseModal(false)}
                    disabled={onProgress}
                    onOk={() => {
                        const { actions } = props.live;
                        const action = _.pick(_.find(props.actionType, {name: 'Reprise'}), '@id');
                        const isOvertime = isOverTimeStarted(actions);
                        const mitemps = extractAction(actions, isOvertime ? 'mi_temps_prolongation' : 'mi_temps');
                        const minute = getRegularTimeForAction(props.live.actions, mitemps);
                        setOnProgress(true);
                        addAction(props.id, {
                            type: action['@id'],
                            teamId: null,
                            minute,
                            teamName: null,
                            data: {
                                actionName: `Début de la seconde période ${isOvertime ? 'de la prolongation' : ''}`,
                                label: isOvertime ? 'reprise_prolongation' : 'reprise',
                                startAt: moment().format('H:mm:ss')
                            }
                        }, props.access).then(response => {
                            window.postMessage(JSON.stringify({
                                action: 'trackEvent',
                                parameters: {
                                    label: 'added_live_score',
                                    value: 'déclarer la reprise'
                                }
                            }), '*');
                            props.addActionLive(props.id, response.data);
                            setShowRepriseModal(false);
                            setTimeout(() => setOnProgress(false), 1000);
                            props.onCancel();
                        })
                    }}
                />
                <EndDeclarationModal 
                    show={showEndMatch} 
                    overtimeText={isOverTimeStarted(props.live.actions) ? 'Séance de tirs au but?' : 'Prolongation et/ou TAB?'}
                    onCancel={() => setShowEndMatch(false)}
                    endLive={() => {
                        const action = _.pick(_.find(props.actionType, {name: 'Fin de match'}), '@id');
                        return handleEndLive(props, action['@id'], {actionName: 'Fin de la rencontre', label: 'fin_de_match'}).then(response => {
                            window.postMessage(JSON.stringify({
                                action: 'trackEvent',
                                parameters: {
                                    label: 'added_live_score',
                                    value: 'déclarer la fin d\'un match'
                                }
                            }), '*');
                            editLive(props.id, {ended: true}, props.access).then(r => {
                                props.endLive(props.id);
                            })
                            props.addActionLive(props.id, response.data);
                            props.onCancel();
                        })
                    }}
                    overtimeContent={isOverTimeStarted(props.live.actions) ? 'En cliquant sur "OK" tu vas notifier tes spectateurs de la fin de la prolongation et pouvoir paramétrer le début de la séance de tirs au but' : 'En cliquant sur "OK" tu vas notifier tes spectateurs de la fin du temps réglementaire et pouvoir paramétrer le début de la prolongation ou de la séance de tirs au but'}
                    endRegularTime={() => {
                        const slug = isOverTimeStarted(props.live.actions) ? 'fin_prolongations' : 'fin_temps_reglementaire';
                        const action = _.pick(_.find(props.actionType, {slug}), '@id');
                        const actionName = isOverTimeStarted(props.live.actions) ? 'Fin de la prolongation' : 'Fin du temps réglementaire';
                        return handleEndLive(props, action['@id'], {actionName, label: slug}).then(response => {
                            props.addActionLive(props.id, response.data);
                        })
                    }}
                />
            </Page>
        </Modal>
    )
}

const renderItemGrid = el => (
    <div className="am-grid-item-inner-content column-num-2" style={{opacity: el.isActive ? 1 : 0.2}}>
        <img className="am-grid-icon" src={el.icon} alt={el.text} />
        <div className="am-grid-text">{el.text}</div>
    </div>
);

const handleEndLive = (props, type, data) => {
    const { actions } = props.live;
    const minute = parseInt(getChronoFromLiveDebut(actions)) < parseInt(getHalfTimeCaracteristique(actions, getLivePeriod(actions))) ? parseInt(getHalfTimeCaracteristique(actions, getLivePeriod(actions))) : parseInt(getChronoFromLiveDebut(actions)); 
    return addAction(props.id, {
        type,
        teamId: null,
        minute,
        teamName: null,
        data
    }, props.access)
} 

const handleClickActions = props => {
    try {
        if(isLiveInProgress(props.live)){
            props.history.push(`${props.to}?action_type=${props.action}&actions=${JSON.stringify(props.live.actions)}&score=${JSON.stringify(props.live.score)}&settings=${JSON.stringify(props.settings)}`);
        }
    }
    catch(e) {}
}

const mapDispatchToProps = dispatch => bindActionCreators({addActionLive, endLive}, dispatch)

DeclarationActionModal.propTypes = {
    access: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    actionType: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    live: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default connect(null, mapDispatchToProps)(DeclarationActionModal);